var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: { title: _vm.pageTitle },
      scopedSlots: _vm._u([
        {
          key: "primaryActions",
          fn: function () {
            return [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.bck"),
                  icon: "fa-light fa-arrow-left",
                  variant: "primary",
                  returnUrl: _vm.returnUrl,
                  isBackButton: true,
                  "aria-label": _vm.$t("common.bck"),
                },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "bottomActions",
          fn: function () {
            return [
              _vm.mode === "create" && _vm.demo
                ? _c(
                    "div",
                    [
                      _vm.isFormValid
                        ? _c("app-button", {
                            attrs: {
                              text: _vm.$t("common.sve"),
                              icon: "fa-light fa-save",
                              variant: "primary",
                            },
                            on: { click: _vm.createMessageRouting },
                          })
                        : _c("app-button", {
                            attrs: {
                              text: _vm.$t("common.sve"),
                              icon: "fa-light fa-save",
                              variant: "primary",
                              disabled: true,
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canEditMessage &&
              _vm.demo
                ? _c("app-button", {
                    attrs: {
                      text: _vm.$t("administration.edit"),
                      icon: "fa-light fa-pencil",
                      variant: "primary",
                    },
                    on: { click: _vm.editModeActivate },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canDeleteMessage &&
              _vm.demo
                ? _c("app-button", {
                    attrs: {
                      text: _vm.$t("rights.delete"),
                      icon: "fa-light fa-trash",
                      variant: "danger",
                    },
                    on: { click: _vm.deleteMessageRouting },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.canEditMessage &&
              _vm.mode === "details" &&
              _vm.editMode === true &&
              _vm.demo
                ? _c(
                    "div",
                    [
                      _vm.isFormValid
                        ? _c("app-button", {
                            attrs: {
                              text: _vm.$t("common.sve"),
                              icon: "fa-light fa-save",
                              variant: "primary",
                            },
                            on: { click: _vm.editMessageRouting },
                          })
                        : _c("app-button", {
                            attrs: {
                              text: _vm.$t("common.sve"),
                              icon: "fa-light fa-save",
                              variant: "primary",
                              disabled: true,
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _vm.rightsProfile.length > 1 && _vm.entityType != 1
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "id-account" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.routing.account_id"))
                            ),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v(" * "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.IdAccountSelected,
                                  expression: "IdAccountSelected",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "id-account",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.IdAccountSelected = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.rightsProfile, function (account) {
                              return _c(
                                "option",
                                {
                                  key: account.idAccount,
                                  attrs: { selected: "" },
                                  domProps: { value: account.idAccount },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(account.accountName) + " "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rightsProfile.length > 1
                    ? _c("b-col", {
                        staticClass: "form-group",
                        attrs: { sm: "6" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _vm.flagCACP &&
                      (_vm.entitiesType == "responder" ||
                        _vm.entitiesType == "decentralised")
                        ? _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_routing_name"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_routing_name"
                              ),
                            },
                            model: {
                              value: _vm.routingName,
                              callback: function ($$v) {
                                _vm.routingName = $$v
                              },
                              expression: "routingName",
                            },
                          })
                        : _vm.flagCACP && _vm.entitiesType == "requester"
                        ? _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_label"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_label"
                              ),
                            },
                            model: {
                              value: _vm.routingName,
                              callback: function ($$v) {
                                _vm.routingName = $$v
                              },
                              expression: "routingName",
                            },
                          })
                        : _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.routing_name_" +
                                  _vm.entitiesType
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.routing_name_" +
                                  _vm.entitiesType
                              ),
                            },
                            model: {
                              value: _vm.routingName,
                              callback: function ($$v) {
                                _vm.routingName = $$v
                              },
                              expression: "routingName",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _vm.flagCACP &&
                      (_vm.entitiesType == "responder" ||
                        _vm.entitiesType == "decentralised")
                        ? _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_routing_description"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_routing_description"
                              ),
                            },
                            model: {
                              value: _vm.routingDescription,
                              callback: function ($$v) {
                                _vm.routingDescription = $$v
                              },
                              expression: "routingDescription",
                            },
                          })
                        : _vm.flagCACP && _vm.entitiesType == "requester"
                        ? _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_description"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_description"
                              ),
                            },
                            model: {
                              value: _vm.routingDescription,
                              callback: function ($$v) {
                                _vm.routingDescription = $$v
                              },
                              expression: "routingDescription",
                            },
                          })
                        : _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.routing_description_" +
                                  _vm.entitiesType
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.routing_description_" +
                                  _vm.entitiesType
                              ),
                            },
                            model: {
                              value: _vm.routingDescription,
                              callback: function ($$v) {
                                _vm.routingDescription = $$v
                              },
                              expression: "routingDescription",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.receiverType == 0 &&
                  _vm.flagCACP &&
                  (_vm.entitiesType == "responder" ||
                    _vm.entitiesType == "decentralised")
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_bic"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_bic"
                              ),
                            },
                            model: {
                              value: _vm.receiverId,
                              callback: function ($$v) {
                                _vm.receiverId = $$v
                              },
                              expression: "receiverId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.receiverType == 0 &&
                      _vm.flagCACP &&
                      _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              disabled: _vm.mode === "details",
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_bic"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_bic"
                              ),
                            },
                            model: {
                              value: _vm.receiverId,
                              callback: function ($$v) {
                                _vm.receiverId = $$v
                              },
                              expression: "receiverId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: true,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.entity_bic_participant"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.entity_bic_participant"
                              ),
                            },
                            model: {
                              value: _vm.BICParticipant,
                              callback: function ($$v) {
                                _vm.BICParticipant = $$v
                              },
                              expression: "BICParticipant",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.receiverType == 0
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _vm.entitiesType == "responder"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.receiver_id_responder"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.receiver_id_responder"
                                  ),
                                },
                                model: {
                                  value: _vm.receiverId,
                                  callback: function ($$v) {
                                    _vm.receiverId = $$v
                                  },
                                  expression: "receiverId",
                                },
                              })
                            : _vm.entitiesType == "requester"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.receiver_id_requester"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.receiver_id_requester"
                                  ),
                                },
                                model: {
                                  value: _vm.receiverId,
                                  callback: function ($$v) {
                                    _vm.receiverId = $$v
                                  },
                                  expression: "receiverId",
                                },
                              })
                            : _vm.entitiesType == "rvm"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.receiver_id_rvm"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.receiver_id_rvm"
                                  ),
                                },
                                model: {
                                  value: _vm.receiverId,
                                  callback: function ($$v) {
                                    _vm.receiverId = $$v
                                  },
                                  expression: "receiverId",
                                },
                              })
                            : _vm.entitiesType == "decentralised"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.receiver_id_responder_decentralised"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.receiver_id_responder_decentralised"
                                  ),
                                },
                                model: {
                                  value: _vm.receiverId,
                                  callback: function ($$v) {
                                    _vm.receiverId = $$v
                                  },
                                  expression: "receiverId",
                                },
                              })
                            : _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.receiver_id"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.receiver_id"
                                  ),
                                },
                                model: {
                                  value: _vm.receiverId,
                                  callback: function ($$v) {
                                    _vm.receiverId = $$v
                                  },
                                  expression: "receiverId",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "entity-type-cacp" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("common.routing.flagCACP.entity_type")
                                )
                            ),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v(" * "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entityTypeCacp,
                                  expression: "entityTypeCacp",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "entity-type-cacp",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.entityTypeCacp = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.entityTypeCacpList, function (type) {
                              return _c(
                                "option",
                                {
                                  key: type.name,
                                  attrs: { selected: "" },
                                  domProps: { value: type.name },
                                },
                                [_vm._v(" " + _vm._s(type.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "entity-group-cacp" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "common.routing.flagCACP.entity_group.title"
                                  )
                                )
                            ),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v(" * "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entityGroupCacp,
                                  expression: "entityGroupCacp",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "entity-group-cacp",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.entityGroupCacp = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.entityGroupCacpList, function (group) {
                              return _c(
                                "option",
                                {
                                  key: group.name,
                                  attrs: { selected: "" },
                                  domProps: { value: group.id },
                                },
                                [_vm._v(" " + _vm._s(group.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  _vm.entitiesType == "requester" &&
                  _vm.mode === "details"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              value: _vm.getDate(_vm.creationDate),
                              disabled: _vm.mode === "details",
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.creation_date"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.creation_date"
                              ),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  _vm.entitiesType == "requester" &&
                  _vm.mode === "details"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          new Date(_vm.modificationDate).getTime() >
                          new Date(_vm.creationDate).getTime()
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  value: _vm.getDate(_vm.modificationDate),
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.modification_date"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.flagCACP.modification_date"
                                  ),
                                },
                              })
                            : _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.modification_date"
                                  ),
                                  placeholderValue: "-",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  _vm.entitiesType == "requester" &&
                  _vm.mode === "details"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          new Date(_vm.serviceStartDate).getTime() >=
                          new Date(_vm.creationDate).getTime()
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  value: _vm.getDate(_vm.serviceStartDate),
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.service_start_date"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.flagCACP.service_start_date"
                                  ),
                                },
                              })
                            : _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.service_start_date"
                                  ),
                                  placeholderValue: "-",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  _vm.entitiesType == "requester" &&
                  _vm.mode === "details"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _vm.deactivationDate
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  value: _vm.getDate(_vm.deactivationDate),
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.deactivation_date"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.flagCACP.deactivation_date"
                                  ),
                                },
                              })
                            : _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: _vm.mode === "details",
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.deactivation_date"
                                  ),
                                  placeholderValue: "-",
                                },
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  (_vm.entitiesType === "responder" ||
                    _vm.entitiesType === "decentralised" ||
                    _vm.entitiesType == "requester")
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _vm.entitiesType === "responder" ||
                          _vm.entitiesType === "decentralised" ||
                          _vm.entitiesType === "requester"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  disabled:
                                    _vm.mode === "details" &&
                                    _vm.editMode === false,
                                  inputLabel: _vm.$t(
                                    "common.routing.flagCACP.billable_bic"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "common.routing.flagCACP.billable_bic"
                                  ),
                                },
                                model: {
                                  value: _vm.billableBic,
                                  callback: function ($$v) {
                                    _vm.billableBic = $$v
                                  },
                                  expression: "billableBic",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "activity-proof" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "common.routing.flagCACP.activity_justification_option"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.activityProof,
                                  expression: "activityProof",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.selectTypeColor,
                              attrs: {
                                readonly: "",
                                id: "activity-proof",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.activityProof = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "null",
                                    hidden: "",
                                    disabled: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.select_active")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "1" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.routing.active")) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "0" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.desactivate")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "label",
                            { attrs: { for: "activity-proof-stet" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.flagCACP.stet_billing_justification_option"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.activityProofStet,
                                  expression: "activityProofStet",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.selectTypeColor,
                              attrs: {
                                readonly: "",
                                id: "activity-proof-stet",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.activityProofStet = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "null",
                                    hidden: "",
                                    disabled: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.select_active")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "1" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.routing.active")) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "0" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.desactivate")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "label",
                            { attrs: { for: "activity-proof-eba" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.flagCACP.eba_billing_justification_option"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.activityProofEba,
                                  expression: "activityProofEba",
                                },
                              ],
                              staticClass: "form-control",
                              class: _vm.selectTypeColor,
                              attrs: {
                                readonly: "",
                                id: "activity-proof-eba",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.activityProofEba = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "null",
                                    hidden: "",
                                    disabled: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.select_active")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "1" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("common.routing.active")) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  staticClass: "color-black-message-details",
                                  attrs: { value: "0" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("common.routing.desactivate")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { cols: "6" } },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "common.routing.flagCACP.subscribed_services_list"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "filter-item-content d-flex justify-content-between p-1 pt-2",
                              staticStyle: { "max-width": "calc(100% - 30px)" },
                              attrs: { id: "srvList-picker-link", href: "#" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    "filter-item-input-complete":
                                      _vm.statusDisplayList.nb > 0,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.statusDisplayList.label))]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa-light fa-chevron-down",
                                attrs: { size: "17px", id: "srvList-chevron" },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "srvList-picker-link",
                                title: _vm.$t(
                                  "common.routing.flagCACP.select_subscribed_services"
                                ),
                                triggers: "focus",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                                placement: "bottom",
                              },
                            },
                            _vm._l(_vm.subscribedServices, function (srv) {
                              return _c(
                                "span",
                                { key: srv.name },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: { value: 1, "unchecked-value": 0 },
                                      model: {
                                        value: srv.state,
                                        callback: function ($$v) {
                                          _vm.$set(srv, "state", $$v)
                                        },
                                        expression: "srv.state",
                                      },
                                    },
                                    [_c("span", [_vm._v(_vm._s(srv.label))])]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.unitary_api_emission_consumer"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.unitary_api_emission_consumer"
                              ),
                            },
                            model: {
                              value: _vm.unitDdv,
                              callback: function ($$v) {
                                _vm.unitDdv = $$v
                              },
                              expression: "unitDdv",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP && _vm.entitiesType == "requester"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.file_exchange_partner"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.file_exchange_partner"
                              ),
                            },
                            model: {
                              value: _vm.bulkDdv,
                              callback: function ($$v) {
                                _vm.bulkDdv = $$v
                              },
                              expression: "bulkDdv",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  _vm.entitiesType == "requester" &&
                  _vm.mode === "details"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled: _vm.mode === "details",
                              inputLabel: _vm.$t(
                                "common.routing.flagCACP.status"
                              ),
                              placeholderValue: _vm.$t(
                                "common.routing.flagCACP.status"
                              ),
                            },
                            model: {
                              value: _vm.statusDo,
                              callback: function ($$v) {
                                _vm.statusDo = $$v
                              },
                              expression: "statusDo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flagCACP &&
                  (_vm.entitiesType === "responder" ||
                    _vm.entitiesType === "decentralised")
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", { attrs: { for: "country" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("common.routing.flagCACP.country"))
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.entityCountry,
                                  expression: "entityCountry",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                                id: "country",
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.entityCountry = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "common.routing.flagCACP.select_country"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.countries, function (country) {
                                return _c(
                                  "option",
                                  {
                                    key: country,
                                    domProps: { value: country },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "countriesAlpha2Code." + country
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.receiverType == 0 && _vm.entitiesType == "decentralised"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              inputLabel: _vm.$t("common.routing.member_id"),
                              placeholderValue: _vm.$t(
                                "common.routing.member_id"
                              ),
                            },
                            model: {
                              value: _vm.memberId,
                              callback: function ($$v) {
                                _vm.memberId = $$v
                              },
                              expression: "memberId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entityType != 1 && (_vm.entityType != 2 || !_vm.flagCACP)
                    ? _c("b-col", { attrs: { sm: "6" } })
                    : _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { cols: "6" } },
                        [
                          _vm.flagCACP &&
                          (_vm.entitiesType == "responder" ||
                            _vm.entitiesType == "decentralised")
                            ? _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.routing.flagCACP.eligible_id"
                                    )
                                  )
                                ),
                              ])
                            : _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common.global.corporate_identifier_type"
                                    )
                                  )
                                ),
                              ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "filter-item-content d-flex justify-content-between p-1 pt-2",
                              staticStyle: { "max-width": "calc(100% - 30px)" },
                              attrs: { id: "emailGrp-picker-link", href: "#" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    "filter-item-input-complete":
                                      _vm.statusDisplay.nb > 0,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.statusDisplay.label))]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa-light fa-chevron-down",
                                attrs: { size: "17px", id: "emailGrp-chevron" },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "emailGrp-picker-link",
                                title: _vm.$t(
                                  "common.select_corporate_identifier_type"
                                ),
                                triggers: "focus",
                                disabled:
                                  _vm.mode === "details" &&
                                  _vm.editMode === false,
                                placement: "bottom",
                              },
                            },
                            _vm._l(
                              _vm.corporateIdentifierType,
                              function (status) {
                                return _c(
                                  "span",
                                  { key: status.name },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          value: 1,
                                          "unchecked-value": 0,
                                        },
                                        model: {
                                          value: status.state,
                                          callback: function ($$v) {
                                            _vm.$set(status, "state", $$v)
                                          },
                                          expression: "status.state",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(status.label)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.entitiesType == "decentralised"
                    ? _c("b-col", {
                        staticClass: "form-group",
                        attrs: { sm: "6" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entitiesType == "decentralised"
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-form-label",
                              attrs: { for: "slider-seuil" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "common.routing.acceptable_error_threshold"
                                  )
                                )
                              ),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v(" * "),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v(_vm._s(_vm.acceptableErrorThreshold))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.acceptableErrorThreshold,
                                expression: "acceptableErrorThreshold",
                              },
                            ],
                            staticClass: "range-slider-streammind",
                            class: _vm.sliderColorClass,
                            attrs: {
                              disabled:
                                _vm.mode === "details" &&
                                _vm.editMode === false,
                              readonly: "",
                              type: "range",
                              min: "1",
                              max: "101",
                              id: "slider-seuil",
                            },
                            domProps: { value: _vm.acceptableErrorThreshold },
                            on: {
                              __r: function ($event) {
                                _vm.acceptableErrorThreshold =
                                  $event.target.value
                              },
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _vm.entitiesType != "decentralised"
                        ? _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.routing.connector"),
                                isTitleUpperCase: false,
                              },
                            },
                            _vm._l(_vm.arrayConfig, function (config, key) {
                              return _c(
                                "b-row",
                                { key: key },
                                [
                                  (key == "0" && _vm.entityType != "2") ||
                                  (key == "1" && _vm.entityType != "0")
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          (key == "0" &&
                                            _vm.entityType == "0") ||
                                          (key == "1" && _vm.entityType == "2")
                                            ? _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-type" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_type_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-type" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_type_" +
                                                            key
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: config.configType,
                                                  expression:
                                                    "config.configType",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectTypeColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-type",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      config,
                                                      "configType",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.resetConfig(
                                                      config
                                                    )
                                                  },
                                                ],
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    hidden: "",
                                                    disabled: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config_type"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.entitiesType == "rvm"
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: { value: "NULL" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.none"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.entitiesType !=
                                              "decentralised"
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: {
                                                        value: "MQSERIES",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.mqseries"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.entitiesType !=
                                              "decentralised"
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: {
                                                        value: "WEBSERVICE",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.web_service"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.entitiesType !=
                                              "decentralised"
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: { value: "FTP" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.ftp"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.entitiesType ==
                                              "decentralised"
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: { value: "S3" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.s3"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.entityType == 2
                                                ? _c(
                                                    "option",
                                                    {
                                                      staticClass:
                                                        "color-black-message-details",
                                                      attrs: {
                                                        value: "DATABASE",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.routing.database"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMQSeries(config) &&
                                  key == "1" &&
                                  _vm.entitiesType != "decentralised" &&
                                  _vm.entityType != "0"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "1" && _vm.entityType == "2"
                                            ? _c(
                                                "label",
                                                { attrs: { for: "config-mq" } },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                { attrs: { for: "config-mq" } },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    config.configMQSeriesId,
                                                  expression:
                                                    "config.configMQSeriesId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectMQSeriesColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-mq",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configMQSeriesId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.mqseriesListSender,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value:
                                                          item.IdConfigRouting,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm.isMQSeries(config) &&
                                      key == "0" &&
                                      _vm.entitiesType != "decentralised" &&
                                      _vm.entityType != "2"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "0" && _vm.entityType == "0"
                                            ? _c(
                                                "label",
                                                { attrs: { for: "config-mq" } },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                { attrs: { for: "config-mq" } },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_" +
                                                            key
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    config.configMQSeriesId,
                                                  expression:
                                                    "config.configMQSeriesId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectMQSeriesColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-mq",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configMQSeriesId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.mqseriesListReceiver,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value:
                                                          item.IdConfigRouting,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWebService(config) &&
                                  key == "1" &&
                                  _vm.entityType != "0"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "1" && _vm.entityType == "2"
                                            ? _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-web" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-web" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_" +
                                                            key
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    config.configWebServiceId,
                                                  expression:
                                                    "config.configWebServiceId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectWebServiceColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-web",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configWebServiceId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.webServiceListSender,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value:
                                                          item.IdWebService,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm.isWebService(config) &&
                                      key == "0" &&
                                      _vm.entitiesType != "decentralised" &&
                                      _vm.entityType != "2"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "0" && _vm.entityType == "0"
                                            ? _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-web" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-web" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_" +
                                                            key
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    config.configWebServiceId,
                                                  expression:
                                                    "config.configWebServiceId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectWebServiceColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-web",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configWebServiceId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.webServiceListReceiver,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value:
                                                          item.IdWebService,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isFTP(config) &&
                                  key == "1" &&
                                  _vm.entityType != "0"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "1" && _vm.entityType == "2"
                                            ? _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-ftp" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-ftp" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_" +
                                                            key
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: config.configFTPId,
                                                  expression:
                                                    "config.configFTPId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectFTPColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-ftp",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configFTPId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.ftpListSender,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value: item.IdFTP,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm.isFTP(config) &&
                                      key == "0" &&
                                      _vm.entitiesType != "decentralised" &&
                                      _vm.entityType != "2"
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          key == "0" && _vm.entityType == "0"
                                            ? _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-ftp" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_connector"
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "label",
                                                {
                                                  attrs: { for: "config-ftp" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.config_name_" +
                                                            key
                                                        )
                                                      ) +
                                                      "\n                   "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                    },
                                                    [_vm._v(" * ")]
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: config.configFTPId,
                                                  expression:
                                                    "config.configFTPId",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              class: _vm.selectFTPColor,
                                              attrs: {
                                                readonly: "",
                                                id: "config-ftp",
                                                disabled:
                                                  _vm.mode === "details" &&
                                                  _vm.editMode === false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    config,
                                                    "configFTPId",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "null",
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.routing.select_config"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.ftpListReceiver,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "color-black-message-details",
                                                      domProps: {
                                                        value: item.IdFTP,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.Name))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.OldCertIdentifier != "" && _vm.entityType == "0"
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "common.routing.authentification_certification"
                                ),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      _c("form-write-group-label-input", {
                                        attrs: {
                                          isMandatory: "",
                                          disabled:
                                            _vm.mode === "details" &&
                                            _vm.editMode === false,
                                          inputLabel: _vm.$t(
                                            "common.routing.certificat_identifier"
                                          ),
                                          placeholderValue: _vm.$t(
                                            "common.routing.certificat_identifier"
                                          ),
                                        },
                                        model: {
                                          value: _vm.CertIdentifier,
                                          callback: function ($$v) {
                                            _vm.CertIdentifier = $$v
                                          },
                                          expression: "CertIdentifier",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _vm.flagCACP &&
                      (_vm.entitiesType == "responder" ||
                        _vm.entitiesType == "decentralised" ||
                        _vm.entitiesType == "requester")
                        ? _c(
                            "label",
                            { attrs: { for: "config-type-active" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("common.routing.flagCACP.activity")
                                  ) +
                                  "\n              "
                              ),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v(" * "),
                              ]),
                            ]
                          )
                        : _c(
                            "label",
                            { attrs: { for: "config-type-active" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("common.routing.config_active")
                                  ) +
                                  "\n              "
                              ),
                              _c("span", { staticClass: "color-red" }, [
                                _vm._v(" * "),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active,
                              expression: "active",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectTypeColor,
                          attrs: {
                            readonly: "",
                            id: "config-type-active",
                            "aria-label":
                              _vm.flagCACP &&
                              (_vm.entitiesType == "responder" ||
                                _vm.entitiesType == "decentralised" ||
                                _vm.entitiesType == "requester")
                                ? _vm.$t("common.routing.flagCACP.activity")
                                : _vm.$t("common.routing.config_active"),
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.active = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                hidden: "",
                                disabled: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_active")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "color-black-message-details",
                              attrs: { value: "1" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("common.routing.active")) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              staticClass: "color-black-message-details",
                              attrs: { value: "0" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("common.routing.desactivate")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }